"use strict";
/**
 * @fileOverview the entry of coordinate
 * @author sima.zhang1990@gmail.com
 */

var Coord = require('./base');

Coord.Cartesian = require('./cartesian');
Coord.Rect = Coord.Cartesian;
Coord.Polar = require('./polar');
Coord.Helix = require('./helix');
module.exports = Coord;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_coord@0.1.0@@antv/coord/lib/index.js
// module id = 353
// module chunks = 0 1 2